import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { NavLink } from "react-router-dom"
import { addCart } from "../../../redux/slices/cartSlices"
import { selectCartItemById } from '../../../redux/slices/cartSlices'

let PizzaBlock = ({ imageUrl, types, sizes, price, title, id }) => {
    const dispatch = useDispatch()

    const cartItems = useSelector(selectCartItemById(id))

    const [count, setCount] = React.useState(0)

    const addCount = cartItems ? cartItems.count : 0

    const onClickAdd = () => {
        const items = {
            price,
            imageUrl,
            title,
            id,
        }
        dispatch(addCart(items))
    }

    return (
        <div className="pizza-block-wrapper">
            <div className="pizza-block">
                <img className="pizza-block__image"
                    src={imageUrl}
                    alt="Pizza" />
                <h4 className="pizza-block__title">{title}</h4>
                <div className="pizza-block__bottom" onClick={onClickAdd}>
                    <div className="pizza-block__price" >{price} BYN</div>
                    <div className="button button--outline button--add" onClick={() => setCount(count + 1)}>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10.8 4.8H7.2V1.2C7.2 0.5373 6.6627 0 6 0C5.3373 0 4.8 0.5373 4.8 1.2V4.8H1.2C0.5373 4.8 0 5.3373 0 6C0 6.6627 0.5373 7.2 1.2 7.2H4.8V10.8C4.8 11.4627 5.3373 12 6 12C6.6627 12 7.2 11.4627 7.2 10.8V7.2H10.8C11.4627 7.2 12 6.6627 12 6C12 5.3373 11.4627 4.8 10.8 4.8Z"
                                fill="white" />
                        </svg>
                        <span >Добавить</span>
                        {addCount > 0 && <i>{addCount}</i>}
                    </div>
                </div>
                <div className="pizza-block__description">
                    <NavLink to={`/description/${id}`}><button>Подробнее</button></NavLink>
                </div>
            </div>
        </div>
    )
}

export default PizzaBlock